import { useEffect, Fragment } from 'react';
import Calendar from '@features/calendar/Calendar';
import Filter from '@features/ui/Filter';
import Content from '@components/content/Content';
import Banner from '@components/banner/Banner';
import Description from '@components/description/Description';
import { useGetCategoryQuery, useGetContentQuery, useGetContiContentQuery } from '@features/api/ScheduleApiSlice';
import { selectedSelectedDate, selectedDrawDate } from '@features/calendar/CalendarSlice';
import {
  setDataMap,
  setDataByDateMap,
  selectedDataMap,
  selectedDataByDateMap,
  selectedCategoryList,
  selectedSubCategoryList,
  selectedL10N,
  selectedIsShowCalendarMark,
} from '@features/ui/UiSlice';
import { useAppDispatch, useAppSelector } from '@hooks/defineRtkTypedHook';
import { useOption } from '@hooks/useOption';
import { getYMDFirstDate, getYMDLastDate, setDataByDate, deepCopy } from '@utils/index';

export const App = () => {
  const option = useOption();
  const dispatch = useAppDispatch();
  const l10n = useAppSelector(selectedL10N);
  const categoryList = useAppSelector(selectedCategoryList);
  const subCategoryList = useAppSelector(selectedSubCategoryList);
  const drawDate = useAppSelector(selectedDrawDate);
  const selectedDate = useAppSelector(selectedSelectedDate);
  const dataMap = useAppSelector(selectedDataMap);
  const dataByDateMap = useAppSelector(selectedDataByDateMap);

  const { data: categoryData } = useGetCategoryQuery({ option });
  const {
    data: scheduleData,
    isSuccess: isScheduleSuccess,
    isLoading: isScheduleLoading,
  } = useGetContentQuery({
    option,
    categoryIdList: categoryList,
    optionalCategoryIdList: subCategoryList,
    searchStartDate: getYMDFirstDate(drawDate?.year, drawDate?.month),
    searchEndDate: getYMDLastDate(drawDate?.year, drawDate?.month),
  });
  const { data: contiData } = useGetContiContentQuery({ option });

  const { banner, description } = contiData || {};
  const isShowCalendarMark = useAppSelector(selectedIsShowCalendarMark);

  useEffect(() => {
    const { dataMap: newDataMap, dataByDateMap: newDataByDateMap } =
      setDataByDate(scheduleData, deepCopy(dataMap), deepCopy(dataByDateMap)) || {};
    dispatch(setDataMap(newDataMap));
    dispatch(setDataByDateMap(newDataByDateMap));

    console.log('dataMap', newDataMap);
    console.log('dataByDateMap', newDataByDateMap);
  }, [scheduleData]);

  useEffect(() => {
    console.log('category', categoryData);
    console.log('content', scheduleData);
    console.log('contiData', contiData);
  }, [categoryData, scheduleData, contiData]);

  return (
    <div className="schedule-wrap">
      <div className="schedule-wrap-flex">
        <div className="schedule-top">
          <Calendar l10n={l10n!} dataByDateMap={dataByDateMap!} isShowCalendarMark={isShowCalendarMark} />
          <Filter data={categoryData} l10n={l10n!} />
          {banner?.isShow && <Banner data={banner?.data} />}
        </div>
        <div className="schedule-bottom">
          {!isScheduleLoading ? (
            <Content
              selectedDate={selectedDate}
              isScheduleSuccess={isScheduleSuccess}
              dataMap={dataMap!}
              dataByDateMap={dataByDateMap!}
              l10n={l10n!}
            />
          ) : (
            <Fragment />
          )}
        </div>
      </div>
      {description?.isShow && <Description data={description?.data} />}
    </div>
  );
};
